import {sprintf} from 'sprintf-js';
export function getPriceWithMandatoryUpsellsFormatted ({priceType, price, mandatoryUpsells, moneyFormat, currency}) {
  let total = 0;

  if (!mandatoryUpsells) {
    mandatoryUpsells = [];
  }

  mandatoryUpsells.forEach((mu) => {
    if (mu.applicableToPriceTypeIds.indexOf(priceType.number) > -1) {
      total += mu.minPrice;
    }
  });

  total += price.price;

  const newTotal = total / 100;
  const decimals = Math.round((newTotal % 1) * 100);

  return sprintf(moneyFormat, newTotal, decimals, currency);
}

function generateMuString (mu) {
  return `${mu.minPriceFormatted} ${mu.name}`;
}

export  function mandatoryUpsellsString (priceType, mandatoryUpsells = [], text) {
  // Generate  aplicable Mandatory upsells
  let applicables = [];
  const pt = parseInt(priceType, 10);
  for (let i = 0; i < mandatoryUpsells.length; i++) {
    if (mandatoryUpsells[i].applicableToPriceTypeIds.indexOf(pt) > -1) {
      applicables.push(generateMuString(mandatoryUpsells[i]));
    }
  }
  if (applicables.length === 1) {
    return ` ${text.and} ${applicables[0]}`;
  }
  else if (applicables.length > 1) {
    const last = applicables[applicables.length - 1];
    applicables.pop();
    const prev = applicables.join(', ');
    return `, ${prev} ${text.and} ${last}`;
  }
  else {
    return '';
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/edp/pricetypeselector/pricetype/utils.js